import { render, staticRenderFns } from "./FormPanel.vue?vue&type=template&id=bef60208&scoped=true"
import script from "./FormPanel.vue?vue&type=script&lang=js"
export * from "./FormPanel.vue?vue&type=script&lang=js"
import style0 from "./FormPanel.vue?vue&type=style&index=0&id=bef60208&prod&lang=less"
import style1 from "./FormPanel.vue?vue&type=style&index=1&id=bef60208&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef60208",
  null
  
)

export default component.exports